module.exports = __webpack_public_path__ + "img/q1.91bcb92d.jpeg";